@if (fileType == FileType.INVOICE)
{
{{ 'shared.invoice' | transloco }}
} @else if (fileType == FileType.CONTRACT)
{
{{ 'shared.contract' | transloco }}
}